"use client";

import Link from "next/link";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { resolveSlotSport } from "@/lib/conditions/sport-aware-slot";
import { areaLinkForSport } from "@/lib/areas/links";

/**
 * "Part of {Area}" in the spot hero (spec 10.4 item 2). The server renders the link for the
 * primary sport; after hydration the sport lens re-targets it through the client-safe route index:
 * the area page for surf or piste when the area (or an ancestor) has one, else the sport's board
 * filtered to the area ("/conditions/wind#area=cornwall").
 */
export function PartOfArea({
  areaSlug,
  areaName,
  defaultSport,
  availableSports,
}: {
  areaSlug: string;
  areaName: string;
  defaultSport: string;
  availableSports: readonly string[];
}) {
  const rawSport = useShallowSearchParam("sport");
  const lens = resolveSlotSport(rawSport, defaultSport, availableSports);
  return (
    <span data-part-of-area={areaSlug}>
      Part of{" "}
      <Link
        href={areaLinkForSport(areaSlug, lens)}
        className="inline-flex min-h-11 items-center font-semibold text-white underline decoration-white/50 underline-offset-2 hover:decoration-white"
      >
        {areaName}
      </Link>
    </span>
  );
}
